import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const groupConfig: PageConfig[] = [
  {
    name: "group",
    title: "Group Application",
    questions: [
      {
        type: "matrixdynamic",
        name: "group",
        title: "Group Members",
        description: "If applying as a group, list all members",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        cellType: "radiogroup",
        columns: [
          {
            name: "groupMemberName",
            cellType: "text",
            title: "Name",
          },
          {
            name: "groupMemberRegistered",
            title: "Registered",
            cellType: "radiogroup",
            choices,
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
];
